import {
    FooterWrapper
}from './style';

const Footer= () => {
    return(
        <FooterWrapper>
            <a target="_blank" href="https://beian.miit.gov.cn">皖ICP备19020827号-1 </a> 
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34019202000731">
                <img src="https://www.pzjdimg.com/hitcloud/home/index/police.png" />
                皖公网安备 34019202000731号
            </a>
        </FooterWrapper>
    )
}   
export default Footer;